import React, { HTMLAttributes } from 'react';
import {
  WysiwygField,
  Image,
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';

import './style.scss';
import { ParagraphUSPSubparagraph as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphUSPSubparagraphProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphUSPSubparagraph: React.FC<ParagraphUSPSubparagraphProps> = ({
  entity,
}) => {
  const paragraph = entity.toJS();

  const title = paragraph.field_title[0]?.value;
  const body = paragraph.field_body[0]?.processed;
  const image = paragraph.field_media_item[0]?.styles?.original;

  return (
    <div className="ParagraphUSPSubparagraph">
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 col-lg-12">
            {image && (
              <div className="ParagraphUSPSubparagraph__image">
                <Image src={image} />
              </div>
            )}
            <h3 className="ParagraphUSPSubparagraph__title">{title}</h3>
            {body && <WysiwygField html={body} />}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphUSPSubparagraph;
